/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';

import { Box, Link, Typography } from '@mui/material';
import Referral from 'src/assets/referral.png';
import { SignInOptions } from './SignInOptions';
import { InternalSignIn } from './InternalSignIn';
import { ExternalSignIn } from './ExternalSignIn';

import { ReferrerType } from 'src/constants';

export const SignInContainer: React.FC = () => {
  const [referrerType, setReferrerType] = useState<ReferrerType | null>(null);

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      sx={{ width: '100%' }}
    >
      <Box
        sx={(theme) => ({
          background: theme.palette.common.white,
          padding: '62px 100px',
          borderRadius: '48px',
          maxWidth: '615px',
          width: '100%',
          [theme.breakpoints.down('md')]: {
            padding: '48px 32px',
          },
        })}
      >
        <Box display="flex" justifyContent="center">
          <img src={Referral} alt="referral" width="195" />
        </Box>
        <Typography
          variant="h2"
          color="primary"
          sx={{
            fontSize: '30px',
            fontWeight: 600,
            marginTop: '40px',
            textAlign: 'center',
          }}
        >
          Refer a friend
        </Typography>
        <Typography
          variant="body1"
          color="primary"
          sx={{
            fontSize: '16px',
            marginTop: '40px',
            textAlign: 'center',
          }}
        >
          Came across the perfect opportunity for your
          <br />
          friend? Put in a good word for your buddy and help
          <br />
          them land their next opportunity at AgileEngine.
        </Typography>
        {!referrerType && <SignInOptions onOptionSelect={setReferrerType} />}
        {referrerType === ReferrerType.INTERNAL && (
          <InternalSignIn onOtherOptionsClick={() => setReferrerType(null)} />
        )}
        {referrerType === ReferrerType.EXTERNAL && (
          <ExternalSignIn onOtherOptionsClick={() => setReferrerType(null)} />
        )}
      </Box>
      <Box display="flex" justifyContent="center" mt={6}>
        <Typography
          variant="body2"
          color="secondary"
          textAlign="center"
          fontSize="0.675rem"
          mx={2}
        >
          <Link href="https://agileengine.com/privacy-policy" target="_blank">
            Privacy policy
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};
